var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":_vm.persistent,"width":_vm.width,"scrollable":_vm.scrollable},model:{value:(_vm.isShowDialog),callback:function ($$v) {_vm.isShowDialog=$$v},expression:"isShowDialog"}},[_c('v-card',{attrs:{"min-width":_vm.width}},[_c('v-card-title',{staticClass:"bg-color-gray py-0",style:({
        height: _vm.headerHeight + 'px',
        width: '100%',
        zIndex: 20
      })},[_c('v-layout',{staticStyle:{"margin-left":"25px"},attrs:{"row":""}},[_vm._t("dialog-title")],2),_vm._v(" "),_c('v-icon',{style:({
          right: 0 + 'px',
          top: _vm.headerHeight / 4 + 'px',
          right: _vm.headerHeight / 4 + 'px',
          zIndex: 21
        }),attrs:{"size":25},on:{"click":_vm.close}},[_vm._v("close")])],1),_vm._v(" "),_c('v-layout',{staticClass:"scroll-y",class:_vm.centered ? 'pa-4' : 'pa-0',attrs:{"column":"","align-space-around":""}},[_vm._t("dialog-content"),_vm._v(" "),_vm._t("dialog-action")],2),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-space-around":""}},[_vm._t("dialog-fix-action")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91966778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_atoms/Dialog.vue
// module id = null
// module chunks = 